import { render, staticRenderFns } from "./PolicyItemUOM.vue?vue&type=template&id=e8e2c96c&"
import script from "./PolicyItemUOM.vue?vue&type=script&lang=js&"
export * from "./PolicyItemUOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports